import {Fancybox} from "@fancyapps/ui";

document.addEventListener('DOMContentLoaded', function (dom) {
    Fancybox.bind('[data-fancybox]', {})
});
